interface ResourcesItem {
  title: string;
  description: string;
  url: string;
  bgColor: string;
}

interface ResourcesProps {
  links: ResourcesItem[];
  isDarkMode: boolean;
}

export function Resources({ links, isDarkMode }: ResourcesProps) {
  return (
    <div className="mx-auto mb-8 flex w-screen flex-row flex-wrap justify-center overflow-x-hidden">
      <div className="flex flex-col items-center space-y-2">
        {links.map((link, index) => (
          <div
            key={index}
            onClick={() => window.open(link.url, "_blank")}
            className={`ml-4 mr-4 mt-2 flex h-[5rem] w-[21.5rem] cursor-pointer flex-col rounded-lg border-2 p-3 transition-transform hover:scale-[1.02] ${
              isDarkMode
                ? `border-darkgreen bg-darkblue text-white [box-shadow:inset_0_-2px_#37b764]`
                : `${link.bgColor} border-brown text-brown [box-shadow:inset_0_-2px_#342e2e]`
            }`}
          >
            <div className="text-lg font-semibold">{link.title}</div>
            <div className="text-sm">{link.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
